import { useMemo } from 'react'

import { useApiTokenContext } from '@/context'
import { useListTrades } from '@/data'
import { useWallet } from '@/hooks/use-wallet'
import { IEvent, IToken, ITrade, TradeAction, TradeStatus } from '@/types'
import {
  getListTradeItemsData,
  getProcessedLastEvent,
  getTitleByType,
  getTradeStatus,
  getTradeStatusTextColorClass,
  getTradeTextColorClass,
} from '@/utils'

export interface ProcessedTrade extends ITrade {
  lastEvent: IEvent | null
  fromToken: IToken | null
  toToken: IToken | null
  minAmountOut: string
  amountOut: string
  amountIn: string
  tradeTimeout: number
}

export const getHistoryTradeInfo = (trade: ProcessedTrade, step: number) => {
  const event = getProcessedLastEvent(trade?.events)
  const state = event?.action as TradeAction
  const status = trade?.status as TradeStatus
  return {
    text: getTradeStatus({ status: status }) ?? getTitleByType({ state, isDetail: false, step }),
    color: getTradeStatusTextColorClass({ status: status }) ?? getTradeTextColorClass({ state, step }),
  }
}
const filterValidTrades = (trades: ProcessedTrade[]): ProcessedTrade[] => {
  return trades.filter(
    (trade) => trade.fromToken?.networkName && trade.toToken?.networkName && trade.amountIn && trade.amountOut
  )
}
export const useFormatListTrades = (options?: { refetchInterval?: number }) => {
  const { listToken } = useApiTokenContext()
  const { walletPubkeys } = useWallet()

  const fromAddress = walletPubkeys.flatMap((wallet) => [wallet.address, wallet.publicKey])

  const { data: listTrade, isFetched } = useListTrades({ fromAddress }, options as any)

  const processedTrades = useMemo(() => {
    if (!listTrade?.data) return []
    const listItems = getListTradeItemsData(listTrade.data, listToken)
    return filterValidTrades(listItems)
  }, [listToken, listTrade])

  return { processedTrades, isFetching: !isFetched }
}
